// Angular
import { Injectable } from '@angular/core';
// Extern
import { Subject } from 'rxjs';
// Models
import { SpinnerStatus } from 'src/app/models/spinner-status.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  codes = {};

  private isSpinning: boolean = false;
  private spinnerMessage: string = 'In progress...';
  private spinnerPercentage: number = 0;
  spinnerSubject = new Subject<SpinnerStatus>();

  notificationSubject = new Subject<string>();
  hideNotificationSubject = new Subject<string>();

  constructor() {}

  createPath(keys: string[]) {
    let last = this.codes;
    for (let i = 0; i < keys.length-1; i++) {
      last[keys[i]] = {};
      last = last[keys[i]];
    }
    if (!Object.keys(last).includes(keys[-1])) {
      last[keys[-1]] = [];
    }
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async runSpinner(message: string = undefined, percentage: number = undefined) {
    this.spinnerMessage = message ? message : 'In progress...';
    this.spinnerPercentage = percentage;
    this.isSpinning = true;
    this.emitSpinner();
    await this.delay(10);
  }

  async stopSpinner() {
    this.spinnerMessage = 'In progress...';
    this.spinnerPercentage = undefined;
    this.isSpinning = false;
    this.emitSpinner();
    await this.delay(10);
  }

  emitSpinner(): void {
    this.spinnerSubject.next({
      isSpinning: this.isSpinning,
      message: this.spinnerMessage,
      percentage: this.spinnerPercentage,
    } as SpinnerStatus);
  }

  notify(...codes: string[]) {
    console.log('CALL NotificationsService.notify()');
    codes.forEach((code: string) => {
      this.notificationSubject.next(code);
    })
  }

  unnotify(...codes: string[]) {
    console.log('CALL NotificationsService.unnotify()');
    codes.forEach((code: string) => {
      this.hideNotificationSubject.next(code);
    })
  }

}
